import DatePickerNative from '@/components/UI/DatePickerNative';
import { DateUtils } from '@/utils/Date.utils';
import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form@latest';
import type { MetadataFieldWithValue } from '@/model/Metadata.model';

export interface DatePickerFieldProps {
  field: MetadataFieldWithValue;
  testId?: string;
}

export const DatePicker: FC<DatePickerFieldProps> = ({ field, testId = 'metadata-date-picker' }) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={`metadata[${field.glossary_api_id}].value`}
      control={control}
      defaultValue={field.value ?? DateUtils.dateNow()}
      rules={{ required: field.required === true && 'This field is required' }}
      render={({ field: { value, onChange, onBlur } }) => (
        <DatePickerNative
          value={value}
          style={{ marginBottom: 0 }}
          onChange={onChange}
          onBlur={onBlur}
          testId={testId}
        />
      )}
    />
  );
};
